export enum EventsRoutingEnum {
  List = 'list',
  Detail = ':id',
}
